const actionTypes = require('./actionTypes');
const insuranceRequestHome = require('./insuranceRequestHome');
const insuranceRequestRoutes = require('./insuranceRequestRoutes');

module.exports = {
    actionTypes,
    insuranceRequestHome,
    insuranceRequestRoutes
};
